import ThemeOptions from './ThemeOptions';
import userProfileReducer from './UserProfileReducer';
import newLoginReducer from './Login/NewLoginReducer';
import forgotPasswordReducer from './Login/ForgotPasswordReducer';

export default {
    ThemeOptions: ThemeOptions,
    // loginData: loginReducer,
    loginData: newLoginReducer,
    userProfileData: userProfileReducer,

    forgotPasswordData: forgotPasswordReducer,
};